export const PREFERRED_LANGUAGE_OPTIONS = [
  { value: 'es', labelKey: 'WAITLIST.OPTIONS.LANG_ES' },
  { value: 'en', labelKey: 'WAITLIST.OPTIONS.LANG_EN' },
  { value: 'br', labelKey: 'WAITLIST.OPTIONS.LANG_BR' },
  { value: 'zh', labelKey: 'WAITLIST.OPTIONS.LANG_ZH' }
];

export const YES_NO_OPTIONS = [
  { value: 'yes', labelKey: 'WAITLIST.OPTIONS.YES' },
  { value: 'no', labelKey: 'WAITLIST.OPTIONS.NO' }
];

export const BUSINESS_TYPE_OPTIONS = [
  { value: 'sole_proprietorship', labelKey: 'WAITLIST.OPTIONS.BUSINESS_TYPE_SOLE' },
  { value: 'sme', labelKey: 'WAITLIST.OPTIONS.BUSINESS_TYPE_SME' },
  { value: 'brand', labelKey: 'WAITLIST.OPTIONS.BUSINESS_TYPE_BRAND' }
];

export const EMPLOYEE_RANGE_OPTIONS = [
  { value: '1', labelKey: 'WAITLIST.OPTIONS.EMPLOYEE_1' },
  { value: '2_5', labelKey: 'WAITLIST.OPTIONS.EMPLOYEE_2_5' },
  { value: '6_20', labelKey: 'WAITLIST.OPTIONS.EMPLOYEE_6_20' },
  { value: '20_plus', labelKey: 'WAITLIST.OPTIONS.EMPLOYEE_20_PLUS' }
];

export const MONTHLY_SALES_OPTIONS = [
  { value: '0_1000', labelKey: 'WAITLIST.OPTIONS.SALES_0_1000' },
  { value: '1000_5000', labelKey: 'WAITLIST.OPTIONS.SALES_1000_5000' },
  { value: '5000_20000', labelKey: 'WAITLIST.OPTIONS.SALES_5000_20000' },
  { value: '20000_100000', labelKey: 'WAITLIST.OPTIONS.SALES_20000_100000' },
  { value: '100000_plus', labelKey: 'WAITLIST.OPTIONS.SALES_100000_PLUS' }
];

export const PRIMARY_CATEGORY_OPTIONS = [
  { value: 'electronics', labelKey: 'WAITLIST.OPTIONS.CATEGORY_ELECTRONICS' },
  { value: 'home', labelKey: 'WAITLIST.OPTIONS.CATEGORY_HOME' },
  { value: 'fashion', labelKey: 'WAITLIST.OPTIONS.CATEGORY_FASHION' },
  { value: 'tools', labelKey: 'WAITLIST.OPTIONS.CATEGORY_TOOLS' },
  { value: 'beauty', labelKey: 'WAITLIST.OPTIONS.CATEGORY_BEAUTY' },
  { value: 'other', labelKey: 'WAITLIST.OPTIONS.CATEGORY_OTHER' }
];

export const PRIMARY_PROBLEM_OPTIONS = [
  { value: 'cant_answer_questions', labelKey: 'WAITLIST.OPTIONS.PROBLEM_CANT_ANSWER' },
  { value: 'losing_sales_delay', labelKey: 'WAITLIST.OPTIONS.PROBLEM_DELAY' },
  { value: 'poor_conversion', labelKey: 'WAITLIST.OPTIONS.PROBLEM_CONVERSION' },
  { value: 'cant_scale_volume', labelKey: 'WAITLIST.OPTIONS.PROBLEM_SCALE' },
  { value: 'algorithm_confusion', labelKey: 'WAITLIST.OPTIONS.PROBLEM_ALGORITHM' }
];

export const DAILY_INQUIRY_OPTIONS = [
  { value: '0_10', labelKey: 'WAITLIST.OPTIONS.INQUIRIES_0_10' },
  { value: '10_50', labelKey: 'WAITLIST.OPTIONS.INQUIRIES_10_50' },
  { value: '50_200', labelKey: 'WAITLIST.OPTIONS.INQUIRIES_50_200' },
  { value: '200_plus', labelKey: 'WAITLIST.OPTIONS.INQUIRIES_200_PLUS' }
];

export const GOAL_INTENT_OPTIONS = [
  { value: 'automate_sales', labelKey: 'WAITLIST.OPTIONS.GOAL_AUTOMATE' },
  { value: 'improve_conversion', labelKey: 'WAITLIST.OPTIONS.GOAL_CONVERSION' },
  { value: 'scale_business', labelKey: 'WAITLIST.OPTIONS.GOAL_SCALE' },
  { value: 'explore_only', labelKey: 'WAITLIST.OPTIONS.GOAL_EXPLORE' }
];

export const WILLINGNESS_TO_PAY_OPTIONS = [
  { value: 'ready_to_pay', labelKey: 'WAITLIST.OPTIONS.PAY_READY' },
  { value: 'depends_on_result', labelKey: 'WAITLIST.OPTIONS.PAY_DEPENDS' },
  { value: 'just_exploring', labelKey: 'WAITLIST.OPTIONS.PAY_EXPLORING' }
];

export const DISCOVERY_OPTIONS = [
  { value: 'youtube', labelKey: 'WAITLIST.OPTIONS.DISCOVERY_YOUTUBE' },
  { value: 'tiktok', labelKey: 'WAITLIST.OPTIONS.DISCOVERY_TIKTOK' },
  { value: 'instagram', labelKey: 'WAITLIST.OPTIONS.DISCOVERY_INSTAGRAM' },
  { value: 'recommendation', labelKey: 'WAITLIST.OPTIONS.DISCOVERY_RECOMMENDATION' },
  { value: 'google', labelKey: 'WAITLIST.OPTIONS.DISCOVERY_GOOGLE' },
  { value: 'other', labelKey: 'WAITLIST.OPTIONS.DISCOVERY_OTHER' }
];

export const SALES_UPLIFT_OPTIONS = [
  { value: '0_10', labelKey: 'WAITLIST.OPTIONS.UPLIFT_0_10' },
  { value: '10_30', labelKey: 'WAITLIST.OPTIONS.UPLIFT_10_30' },
  { value: '30_50', labelKey: 'WAITLIST.OPTIONS.UPLIFT_30_50' },
  { value: '50_plus', labelKey: 'WAITLIST.OPTIONS.UPLIFT_50_PLUS' }
];

export const LEAD_TIER_KEYS = {
  ideal: 'SUPERADMIN.WAITLIST_TAB.LEAD_TIER_IDEAL',
  medium: 'SUPERADMIN.WAITLIST_TAB.LEAD_TIER_MEDIUM',
  low: 'SUPERADMIN.WAITLIST_TAB.LEAD_TIER_LOW'
};

export const getOptionLabel = (options, value, t, fallback = '—') => {
  const option = options.find(item => item.value === value);
  return option ? t(option.labelKey) : (value || fallback);
};

export const parseBooleanSelect = value => {
  if (value === 'yes') return true;
  if (value === 'no') return false;
  return null;
};

export const formatBooleanSelect = value => {
  if (value === true) return 'yes';
  if (value === false) return 'no';
  return '';
};